import '../css'

$(document).on('click', '#showRemainingQuestions', function(e) {
  e.preventDefault()
  let questionNumbers = $('.radio').map(() => this.getAttribute('data-question')).get()
  let checked = $('.radio:checked').map(() => this.getAttribute('data-question')).get()

  questionNumbers = questionNumbers.filter((el, ix, self) => self.indexOf(el) == ix) // Unique values
  questionNumbers = questionNumbers.filter((el) => checked.indexOf(el) == -1) // Remove answered questions

  let parent = $('#remainingQuestions')
  parent.find('span:first-child').removeClass('d-none')
  parent.find('span:last-child').text(questionNumbers.join(', '))
})

// Not sure what this is meant to guard against
$(function() {
  if ($('form.edit_test_taken').length > 0) {
    $(document).on('keydown', function(e) {
      if (e.key == 'Enter') e.preventDefault()
    })
  }
})
